/**
 * Syncs variant option labels (size / color) with the active selection.
 */
(function () {
  function getOptionValue(detail, optionKey) {
    if (!detail) return null;
    if (
      detail.variant &&
      Object.prototype.hasOwnProperty.call(detail.variant, optionKey)
    ) {
      var v = detail.variant[optionKey];
      if (v != null && v !== '') return v;
    }
    if (detail.currentlySelectedValues && detail.currentlySelectedValues.length) {
      var found = detail.currentlySelectedValues.find(function (o) {
        return o.index === optionKey;
      });
      if (found) return found.value;
    }
    return null;
  }

  function sectionApplies(variants, detail, section) {
    if (detail.variant) {
      return variants.some(function (v) {
        return v.id === detail.variant.id;
      });
    }
    if (!detail.currentlySelectedValues || !detail.currentlySelectedValues.length) {
      return false;
    }
    return detail.currentlySelectedValues.every(function (sel) {
      var field = section.querySelector(
        '[data-variant-input][data-index="' + sel.index + '"]'
      );
      if (!field) return false;
      if (field.tagName === 'SELECT') {
        return field.value === sel.value;
      }
      if (field.type === 'radio') {
        var checked = section.querySelector(
          '[data-variant-input][data-index="' +
            sel.index +
            '"]:checked'
        );
        return checked && checked.value === sel.value;
      }
      return field.value === sel.value;
    });
  }

  var optionLabelSelector = '[data-selected-size], [data-variant-color-label]';

  function updateLabelsInSection(section, detail) {
    section.querySelectorAll(optionLabelSelector).forEach(function (el) {
      var key = el.getAttribute('data-option-key');
      if (!key) return;
      var text = getOptionValue(detail, key);
      if (text != null && text !== '') {
        el.textContent = text;
      }
    });
  }

  function onVariantChange(e) {
    var detail = e.detail;
    if (!detail) return;

    document.querySelectorAll('.product-section').forEach(function (section) {
      var variantsJson = section.querySelector('[data-variant-json]');
      if (!variantsJson) return;
      var variants;
      try {
        variants = JSON.parse(variantsJson.textContent);
      } catch (err) {
        return;
      }
      if (sectionApplies(variants, detail, section)) {
        updateLabelsInSection(section, detail);
      }
    });
  }

  function onVariantInputChange(e) {
    var input = e.target && e.target.closest
      ? e.target.closest('[data-variant-input]')
      : null;
    if (!input) return;

    if (input.tagName === 'INPUT' && input.type === 'radio' && !input.checked) {
      return;
    }

    var section = input.closest('.product-section');
    if (!section) return;

    var key = input.dataset.index;
    if (!key) return;

    var span = section.querySelector(
      '[data-option-key="' + key + '"]'
    );
    if (span && span.matches(optionLabelSelector)) {
      span.textContent = input.value;
    }
  }

  document.addEventListener('variant:change', onVariantChange);
  document.addEventListener('change', onVariantInputChange, true);
})();

/**
 * Keep AJAX add-to-cart + drawer behavior for <product-form> (accessory slider, etc.)
 * aligned with cart type settings — matches flex PDP / high-variant pattern.
 */
(function () {
  if (window.__fins4lifeProductFormCartHook) return;
  window.__fins4lifeProductFormCartHook = true;
  document.addEventListener('product-form:cart:navigate', function (event) {
    if (
      typeof theme !== 'undefined' &&
      theme.settings &&
      theme.settings.cartType !== 'page'
    ) {
      event.preventDefault();
    }
  });
  document.addEventListener('product-form:submit:success', function () {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });
})();

/**
 * Remove spacer-only paragraphs from product description RTE (e.g. `<p data-…>&nbsp;</p>`).
 * Liquid replace cannot match arbitrary attributes on `<p>`; this runs after render.
 */
function stripEmptyRteParagraphs(root) {
  if (!root || !root.querySelectorAll) return;
  root.querySelectorAll('p').forEach(function (p) {
    if (p.querySelector('img, video, iframe, svg, picture')) return;
    var text = (p.textContent || '')
      .replace(/\u00A0/g, ' ')
      .replace(/\u200B/g, '')
      .trim();
    if (text.length === 0) {
      p.remove();
    }
  });
}

function initProductDescriptionRteCleanup(root) {
  var scope = root || document;
  scope.querySelectorAll('.product-block--description .rte').forEach(
    stripEmptyRteParagraphs
  );
}

function initAccessorySlideshows(root) {
  var scope = root || document;
  scope.querySelectorAll('[data-accessory-slideshow]').forEach(function (el) {
    if (el.classList.contains('flickity-enabled')) return;
    if (el.querySelectorAll('.accessory-collection-slider__slide').length <= 1) {
      return;
    }
    if (typeof theme === 'undefined' || !theme.Slideshow) return;
    var rtl = theme.config && theme.config.rtl;
    var accessorySlideshow = new theme.Slideshow(el, {
      prevNextButtons: el.dataset.controls === 'arrows',
      pageDots: el.dataset.controls !== 'arrows',
      adaptiveHeight: true,
      wrapAround: false,
      cellAlign: rtl ? 'right' : 'left',
      rightToLeft: !!rtl,
    });
    requestAnimationFrame(function () {
      if (accessorySlideshow && typeof accessorySlideshow.resize === 'function') {
        accessorySlideshow.resize();
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  if (typeof theme !== 'undefined' && theme.Modals) {
    var modalEl = document.getElementById('CustomSizeModal');
    if (modalEl) {
      new theme.Modals('CustomSizeModal', 'custom-size', { solid: true });
    }
  }

  var customSizeModal = document.getElementById('CustomSizeModal');
  if (customSizeModal) {
    var inner = customSizeModal.querySelector('.custom-size-modal__inner');
    var canonical = customSizeModal.getAttribute('data-custom-size-email');
    if (inner && canonical && !inner.querySelector('a[href^="mailto:"]')) {
      var escaped = canonical.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var re = new RegExp(escaped, 'gi');
      var html = inner.innerHTML;
      var next = html.replace(re, function (shown) {
        return (
          '<a href="mailto:' +
          encodeURIComponent(canonical) +
          '">' +
          shown +
          '</a>'
        );
      });
      if (next !== html) {
        inner.innerHTML = next;
      }
    }
  }

  initAccessorySlideshows();
  initProductDescriptionRteCleanup();
});

document.addEventListener('shopify:section:load', function (event) {
  initAccessorySlideshows(event.target);
  initProductDescriptionRteCleanup(event.target);
});
